import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const initialState = {
	isAuth: false,
	userData: {},
	token: "",
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		loginAction: (state, action) => {
			const payload = action.payload;
			const { login, userData, token } = payload;

			const newState = {
				isAuth: login,
				userData: userData,
				token: token,
			};
			state.isAuth = newState.isAuth;
			state.userData = newState.userData;
			state.token = newState.token;
		},
		logOutAction: (state, action) => {
			state.isAuth = false;
			state.userData = {};
			state.token = "";
		},
		updateUserAction: (state, action) => {
			const payload = action.payload;
			const { userData } = payload;
			const newState = {
				userData: userData,
			};
			state.userData = newState.userData;
		},
		// PLAN-010 Phase 8: Switch active role and update token
		switchRoleAction: (state, action) => {
			const { activeRole, token } = action.payload;
			state.userData.activeRole = activeRole;
			if (token) {
				state.token = token;
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(PURGE, () => {
			return initialState;
		});
	},
});

export const { loginAction, logOutAction, updateUserAction, switchRoleAction } =
	authSlice.actions;
export default authSlice.reducer;
